import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import Markdown from 'markdown-to-jsx';
import { seoVars } from './sections';
import { normalizeAiContent } from './aiContent';
import IntakePanel from '../intake-panel';

const CitySeoContent = memo(({ city, locationId, aiContent = null }) => {
  const intl = useIntl();
  if (!city) return null;
  const title = intl.formatMessage({ id: 'containers.city.seo.location.title' }, seoVars(intl, city));
  return <div className="c-city-seo">
    <h1 className="l-headline--primary"><Markdown options={{ forceBlock: false }}>{title}</Markdown></h1>
    <IntakePanel showSearch city={city} locationId={locationId} aiContent={normalizeAiContent(aiContent)} />
  </div>;
});
export default CitySeoContent;
